import Head from 'next/head'

const PinaMetadata = ({ data = {}, noIndex = false, children }) => {

  if (data && data.url && /^\//.test(data.url)) {
    // path relative to host
    data.url = `${process.env.NEXT_PUBLIC_BASE_URL}${data.url}`
  }

  const common = {
    'url': data.url,
    'title': data.title,
    'description': data.description,
    'keywords': data.keywords,
    'image': data.image || data?.image_fallback || `${process.env.NEXT_PUBLIC_BASE_URL}/assets/images/pina.jpg`,
  }

  const og = {
    'locale': data.og?.locale || 'id_ID',
    'type': data.og?.type || 'website',
    'site_name': data.og?.site_name || 'Pina Indonesia',
    'url': data.og?.url || common.url,
    'title': data.og?.title || common.title,
    'description': data.og?.description || common.description,
    'image': data.og?.image || common.image,
    'image:secure_url': data.og?.image_secure_url || common.image,
    'image:type': data.og?.image_type || 'image/jpeg',
    'image:width': data.og?.image_width === null ? data.og?.image_width : '300',
    'image:height': data.og?.image_height === null ? data.og?.image_height : '300',
    'image:alt': data.og?.image_alt || common.description,
  }

  const tw = {
    'domain': process.env.NEXT_PUBLIC_BASE_URL || 'https://pina.id',
    'twitter:site': '@PINA_ID',
    'url': data.twitter?.url || common.url,
    'title': data.twitter?.title || common.title,
    'description': data.twitter?.description || common.description,
    'card': data.twitter?.card || 'summary_large_image',
    'image': data.twitter?.image || common.image,
    'image:alt': data.twitter?.image_alt || common.description,
  }

  // const other = {
  //   'apple-mobile-web-app-title': data.other.apple_mobile_web_app_title || data.title,
  //   'mobile-web-app-capable': data.other.mobile_web_app_capable || 'yes'
  // }

  // console.log({ common, og, tw, data })

  return (
    <Head>
      <title>{common?.title}</title>

      { common.url && <link rel="canonical" href={common.url} /> }

      <meta key="apple:title" name="apple-mobile-web-app-title" content={common?.title} />
      <meta key="mobile:web-app-capable" name="mobile-web-app-capable" content="yes" />
      <meta key="bot:noindex" name="robots" content="all" />
      <meta name="facebook-domain-verification" content="bqtrpjhvnav7f8h5o2etcspq3gexl9" />
      
      {/* common */}
      { 
        Object.entries(common).map(([key, val]) => (
          val && <meta key={key} name={key} content={val} />
        )) 
      }

      {/* general open graph */}
      { 
        Object.entries(og).map(([key, val]) => (
          val && <meta key={`og:${key}`} property={`og:${key}`} content={val} />
        )) 
      }

      {/* twitter open graph */}
      {
        Object.entries(tw).map(([key, val]) => (
          val && <meta key={`twitter:${key}`} property={`twitter:${key}`} content={val} />
        )) 
      }

      {/* no-index */}
      {
        noIndex &&
        <meta key="bot:noindex" name="robots" content="noindex, nofollow" />
      }

      {/* children */}
      { children }
    </Head>
  )
}

export default PinaMetadata